module.exports = __webpack_public_path__ + "static/bc-953af99eb54ac29a85e8df236667a480.png";